import React, { useEffect, useRef } from "react";

// Assets
import IconClose from "../../Assets/SVGs/Icons/UI/Close";

// Components
import ButtonPill from "../Buttons/ButtonPill";
import VideoPlayer from "../Layouts/Content/Watch/VideoSingle/VideoPlayer/VideoPlayer";

// Context
import { PopupType, usePopup } from "../../Context/PopupContext";

const CHANNEL_TRAILER_URL =
    "https://storage.ickonic.com/IckonicVideo/asset-70d9c3f1-8785-4364-921d-e2e2701389d9/Ickonic_Channel_Trailer_2026.m3u8";

const FrontTrailerPopup: React.FC = () => {
    const dialogRef = useRef<HTMLDialogElement>(null);
    const { closePopupIfType, isPopupOpen } = usePopup();
    const isOpen = isPopupOpen(PopupType.FRONT_TRAILER);

    const closeTrailer = () => {
        closePopupIfType(PopupType.FRONT_TRAILER);
    };

    useEffect(() => {
        const dialog = dialogRef.current;
        if (!dialog) return;

        if (!isOpen) {
            if (dialog.open) dialog.close();
            return;
        }

        const previousBodyOverflow = document.body.style.overflow;
        if (!dialog.open) dialog.showModal();
        document.body.style.overflow = "hidden";

        return () => {
            document.body.style.overflow = previousBodyOverflow;
            if (dialog.open) dialog.close();
        };
    }, [isOpen]);

    useEffect(() => {
        return () => closePopupIfType(PopupType.FRONT_TRAILER);
    }, [closePopupIfType]);

    return (
        <dialog
            ref={dialogRef}
            className="front-trailer-modal"
            aria-labelledby="front-trailer-modal-title"
            onClose={closeTrailer}
            onClick={(event) => {
                if (event.target === event.currentTarget) {
                    closeTrailer();
                }
            }}
        >
            <div className="front-trailer-modal__dialog">
                <button
                    className="front-trailer-modal__close"
                    type="button"
                    aria-label="Close trailer"
                    onClick={closeTrailer}
                >
                    <IconClose iconFill="white" />
                </button>

                <div className="front-trailer-modal__player">
                    {isOpen && (
                        <VideoPlayer
                            src={CHANNEL_TRAILER_URL}
                            autoPlay={true}
                            playbackAllowed={true}
                            useTrailerLink={true}
                        />
                    )}
                </div>

                <div className="front-trailer-modal__copy">
                    <p>Inside Ickonic</p>
                    <h2 id="front-trailer-modal-title">
                        A wider view starts here.
                    </h2>
                    <ButtonPill label="Close trailer" onClick={closeTrailer} />
                </div>
            </div>
        </dialog>
    );
};

export default FrontTrailerPopup;
